/**
 * The parameters of a page that a KPI link carries to its destination (ADR 9069). A card counted the rows
 * of a perimeter (the market, the season, a run); the list it opens must read the same perimeter, and
 * nothing else of the page it leaves. Shared by the plain-table link (`tableFilterHref`) and the ranked-table
 * link (`rankedViewHref`).
 */

/** `search` reduced to the parameters named by `carry`, in that order; a missing or blank one is left out. Pure. */
export function carriedSearch(search: string, carry: readonly string[]): string {
  const source = new URLSearchParams(search);
  const kept = new URLSearchParams();
  for (const name of carry) {
    const value = source.get(name);
    if (value !== null && value.trim() !== '') kept.set(name, value);
  }
  const text = kept.toString();
  return text === '' ? '' : `?${text}`;
}
